import filters from './list-filters';
import configProfileForm from './profileItems';
import configCaheItems from './cacheItems';

const env = (key) => process.env[`VUE_APP_${key}`];

export default {
  test: env('TEST'),
  url: {
    passwordReset: 'public/passwordreset',
    cges: env('CGES_URL'),
    manual: env('MANUAL_URL'),
    oldProd: env('OLD_PROD_URL'),
    currentPre: env('CURRENT_PRE_URL'),
    currentProd: env('CURRENT_PROD_URL'),
  },
  upload: {
    server: env('UPLOAD_SERVER'),
    rep: env('UPLOAD_REP'),
  },
  announcements: {
    // default announcements location sent as filter in annoucements request
    location: env('ANNOUNCEMENTS_LOCATION'),
  },
  news: {
    idNews: env('ID_NEWS'),
  },
  listFilters: {
    R: filters.R,
    approvals: filters.approvals,
    pend: filters.pend,
  },
  ticketExport: {
    R: 'export/request',
    I: 'export/incident',
    P: 'export/problem',
  },
  initialFilters: {
    all: ['FIX', 'OP', 'DEL', 'PEND_APRO', 'PL_ENT', 'CL', 'CNCL', 'RCHZ', 'PEND_PRES'],
    filterStatus: {
      FIX: { text: 'Pte. confirmar cierre', initials: 'PCC', color: '#ed7d31' },
      OP: { text: 'Abierta', initials: 'A', color: '#e2e200' },
      DEL: { text: 'Planificada', initials: 'P', color: '#ed7d31' },
      PEND_APRO: { text: 'Pte aprobar', initials: 'PA', color: '#e2e200' },
      PL_ENT: { text: 'Pte implantar', initials: 'PE', color: '#e2e200' },
      CL: { text: 'Cerrada', initials: 'C', color: '#808080' },
      CNCL: { text: 'Cancelada', initials: 'C', color: '#808080' },
      RCHZ: { text: 'Rechazada', initials: 'R', color: '#808080' },
      PEND_PRES: { text: 'Pte. presupuesto', initials: 'PP', color: '#e2e200' },
      APPVAL: { text: 'Aprobada', initials: 'AP', color: '#e2e200' },
    },
    pending: [
      { text: 'Pte. confirmar cierre', initials: 'PCC', status: 'FIX' },
      { text: 'Planificada', initials: 'P', status: 'DEL' },
      { text: 'Pte aprobar', initials: 'PA', status: 'PEND_APRO' },
    ],
    requestTic: [
      { text: 'Abierta', initials: 'A', status: 'OP' },
      { text: 'Pte. confirmar cierre', initials: 'PCC', status: 'FIX' },
      { text: 'Planificada', initials: 'P', status: 'DEL' },
      { text: 'Pte implantar', initials: 'PE', status: 'PL_ENT' },
      { text: 'Pte aprobar', initials: 'PA', status: 'PEND_APRO' },
      { text: 'Rechazada', initials: 'R', status: 'RCHZ' },
      { text: 'Cerrada', initials: 'C', status: 'CL' },
      { text: 'Cancelada', initials: 'C', status: 'CNCL' },
      { text: 'Pte. presupuesto', initials: 'PP', status: 'PEND_PRES' },
    ],
    requestNoTic: [
      { text: 'Abierta', initials: 'A', status: 'OP' },
      { text: 'Pte. confirmar cierre', initials: 'PCC', status: 'FIX' },
      { text: 'Planificada', initials: 'P', status: 'DEL' },
      { text: 'Pte implantar', initials: 'PE', status: 'PL_ENT' },
      { text: 'Pte aprobar', initials: 'PA', status: 'PEND_APRO' },
      { text: 'Rechazada', initials: 'R', status: 'RCHZ' },
      { text: 'Cerrada', initials: 'C', status: 'CL' },
      { text: 'Cancelada', initials: 'C', status: 'CNCL' },
    ],
  },
  chipColorStatus: {
    FIX: { text: 'Pte. confirmar cierre', initials: 'PCC', color: '#ed7d31' },
    OP: { text: 'Abierta', initials: 'A', color: '#e2e200' },
    DEL: { text: 'Planificada', initials: 'P', color: '#ed7d31' },
    PEND_APRO: { text: 'Pte aprobar', initials: 'PA', color: '#e2e200' },
    PL_ENT: { text: 'Pte implantar', initials: 'PE', color: '#e2e200' },
    CL: { text: 'Cerrada', initials: 'C', color: '#808080' },
    CNCL: { text: 'Cancelada', initials: 'C', color: '#808080' },
    RCHZ: { text: 'Rechazada', initials: 'R', color: '#808080' },
    PEND_PRES: { text: 'Pte. presupuesto', initials: 'PP', color: '#e2e200' },
  },
  profileForm: {
    sections: [
      { sectionProfile: 'Mis teléfonos', symbolSection: 'mdi-phone' },
      { sectionProfile: 'Notificaciones por Whatsapp', symbolSection: 'mdi-whatsapp' },
      { sectionProfile: 'Mi centro de trabajo', symbolSection: 'mdi-city' },
      { sectionProfile: 'Mi puesto de trabajo', symbolSection: 'mdi-city' },
      { sectionProfile: 'Datos personales', symbolSection: 'mdi-card-account-details' },
    ],
    form: configProfileForm,
    errorWhatsapp: 'DuplicateNumberForWhatsapp',
  },
  piwik: {
    id: env('ID_PIWIK'),
    host: env('URL_PIWIK'),
  },
  matomo: {
    host: env('URL_MATOMO'),
    siteId: env('ID_MATOMO'),
    siteIdApp: env('ID_MATOMO_APP'),
  },
  cache: {
    items: configCaheItems,
  },
  suggestion: {
    idSuggestion: env('ID_ELEMENT_SUGGESTION'),
  },
  problem: {
    idProblem: env('ID_ELEMENT_PROBLEM'),
  },

  recaptchaKey: env('RECAPTCHA_KEY'),

  dashboard: {
    pendingRequestsInitialFilters: ['FIX', 'DEL', 'PEND_APRO'],
    pendingRequestsSupportedFilters: ['FIX', 'DEL', 'PEND_APRO'],
    myRequestsInitialFilters: ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO'],
    myRequestsSupportedFilters: ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO', 'RCHZ'],

    myRequestsTICInitialFilters: ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO', 'PEND_PRES'],
    myRequestsTICSupportedFilters: ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO', 'RCHZ', 'PEND_PRES'],

    filtersColors: {
      OP: '#e2e200',
      FIX: '#ed7d31',
      PL_ENT: '#e2e200',
      DEL: '#ed7d31',
      PEND_APRO: '#e2e200',
      CL: '#808080',
      CNCL: '#808080',
      RCHZ: '#808080',
      DRCHZ: '#cecece',
      PEND_PRES: '#e2e200',
    },
  },
  faqs: {
    idFormApplication: env('FORM_APPLICATION_ID'),
    idApplicationMics: env('APPLICATION_MICS_ID'),
  },
  notifications: {
    timeout: 5000,
    timeoutPlus: 10000,
  },
  claim: {
    category: 402610,
  },
  categoryFamily: parseInt(env('CATEGORY_FAMILY_ID'), 10),
  elementFamily: parseInt(env('ELEMENT_FAMILY_ID'), 10),
  rolesResolver: ['admin', 'WT_EQUIPO_PROVINCIAL_TIC'],
  catalogoResolver: ['AA223478158A01F8A7BE000C2975418F'],
  home: {
    caducidadContrasena: 15,
  },
  clone: {
    category: 402610,
    name: 'clone',
  },
  ticketDetailView: {
    character: 50,
  },
  session: {
    timeoutCheck: 60 * 1000,
    timeoutWarning: 1620 * 1000,
  },
  assigneeField: {
    groupbyAssignee: 'codigo',
    element: 3,
    ordenAssignee: {
      PROVEEDOR_SISTEMAS: 1,
      PROVEEDOR_DESARROLLO: 2,
    },
  },
  ticketType: {
    pendApro: 'PEND_APRO',
  },
  notificationsView: {
    bussinesType: {
      news: ['news'],
      requests: ['608a5f0dfdbc36491c995a7b', '608a5f2afdbc36491c995a7c', '6034dbde8c72ae370465467f', '6034dbc08c72ae370465467e', '6034dbe98c72ae3704654680'],
      applications: ['62010898d1827bba9cca0a32', '62010887d1827b25cdca0a29'],
      others: ['6034dbf78c72ae3704654681', '6553677a298f818934dbd312'],
      interruptions: ['62010898d1827bba9cca0a32', '62010887d1827b25cdca0a29'],
      communications: ['6034dbf78c72ae3704654681', '6553677a298f818934dbd312'],
    },
    icon: {
      email: 'icon-ayudadigital-arroba',
      push: 'icon-ayudadigital-appmovil',
      firebase: 'icon-ayudadigital-appmovil',
      sms: 'icon-ayudadigital-appmovil',
      generic: 'icon-ayudadigital-appmovil',
      whatsapp: 'icon-ayudadigital-whatsapp',
      news: 'icon-ayudadigital-novedades02',
    },
    label: {
      applications: 'applications',
      requests: 'requests',
      news: 'news',
      others: 'others',
    },
  },
  status: {
    noActive: ['CL', 'CNCL', 'RCHZ'],
  },
  uuidAplicacion: {
    origen: '45EF77B3E0BD01F7BEA0001CC4BEAABC',
  },
  company: {
    sasId: 'ED90983754E201DE9CAC001CC416E56E',
    emailPattern: '@juntadeandalucia.es',
  },
  month: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  tagActivity: {
    acceptClosing: {
      idTagApp: '400057',
      idTagWeb: '400056',
    },
    cancel: {
      idTagApp: '400059',
      idTagWeb: '400058',
    },
    comment: {
      idTagApp: '400055',
      idTagWeb: '400054',
    },
    transfer: {
      idTagApp: '400061',
      idTagWeb: '400060',
    },
    approve: {
      idTagApp: '400063',
      idTagWeb: '400062',
    },
    reject: {
      idTagApp: '400065',
      idTagWeb: '400064',
    },
    interested: {
      idTagApp: '400067',
      idTagWeb: '400066',
    },
    follow: {
      idTagApp: '400069',
      idTagWeb: '400068',
    },
    resolve: {
      idTagApp: '400071',
      idTagWeb: '400070',
    },
    claim: {
      idTagApp: '400073',
      idTagWeb: '400072',
    },
  },
  tipoNegocio: {
    paradaPlanificada: '62010898d1827bba9cca0a32',
    incidenciaImpacto: '62010887d1827b25cdca0a29',
    Registro: '608a5f0dfdbc36491c995a7b',
    AprobacionRechazo: '6034dbc08c72ae370465467e',
    ReasignacionAProveedor: '608a5f2afdbc36491c995a7c',
    PlanificacionDeEjecucion: '6034dbe98c72ae3704654680',
    Resolucion: '6034dbde8c72ae370465467f',
  },
  canales: {
    sms: {
      id: '6194eb11cf505f23b515c95c',
      modo: 'sms',
    },
    whatsapp: {
      id: '62693747503de70aef1fc0a9',
      modo: 'whatsapp',
    },
    firebase: {
      id: '60881d46b514031040d6138f',
      modo: 'firebase',
    },
    email: {
      id: '60881caed271ca147cf6ce08',
      modo: 'email',
    },
    websocket: {
      id: '662a16a8f78e5704e0399844',
      modo: 'websocket',
    },
  },
  pulsoDigital: {
    listadoCIExcepcional: [
      'URGENCIAS',
      'MODULO GESTION DEL CONOCIMIENTO',
      'ESTACION CLINICA',
      'MODELO DE DATOS Y ETL DE MTI-ACCESIBILIDAD CONSULTAS EXTERNAS',
      'EG- ESTACION DE GESTION',
      'DIRAYA_COMPONENTES COMUNES DE LA CAPA CLIENTE',
      'ARIA CORPORATIVO',
      'RXXI PRESCRIPCIONES',
      'ESTACION CLINICA DE CUIDADOS',
      'FARMA HOSPITALES (ATHOS)',
      'PDI PRUEBAS DIAGNOSTICAS POR IMAGEN',
      'SERVICIO DE COMUNICACIONES WAN',
    ],
  },
};
